export default "__VITE_ASSET__BuSZaLuS__"